import React from 'react';
import './Footer.css';

const Footer = () => (
  <div>
    <h3 className="footer">A Microverse Capstone Project by Mohamed A. Ighe</h3>
  </div>
);

export default Footer;
